import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { AuthPageWrapper } from '@app/components';

import { CreateAccountForm } from './CreateAccountForm';

const cnBem = createBemBlockBuilder(['authPageWrapper']);

export const CreateAccountPage = () => {
  const { $t } = useIntl();

  return (
    <>
      <Helmet>
        <title>
          {$t({
            id: 'createAccount.title',
            defaultMessage: 'Create account - EBSCO Locate',
          })}
        </title>
      </Helmet>
      <AuthPageWrapper containerClassName={cnBem('__createAccountContainer')}>
        <CreateAccountForm />
      </AuthPageWrapper>
    </>
  );
};
